import { useCallback, useRef, useState } from 'react';

export function useToast() {
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const toastTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((msg: string) => {
    if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
    setToastMessage(msg);
    toastTimerRef.current = setTimeout(() => setToastMessage(null), 3500);
  }, []);

  const dbError = useCallback(
    (context: string) => (err: unknown) => {
      console.error(`${context} Error:`, err);
      showToast(`${context} 처리 중 오류가 발생했습니다. 네트워크 및 권한을 확인해주세요.`);
    },
    [showToast]
  );

  return { toastMessage, showToast, dbError };
}
